import { FunctionComponent, useState } from "react"
import { FieldErrors, UseFormRegister } from "react-hook-form"
import { FormInput } from "./styles"
import { FormControl, FormErrorMessage, InputGroup, InputRightAddon } from "@chakra-ui/react"
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons"


interface IInputPassword {
    errors: FieldErrors<{
        senha: string;
    }>,
    register: UseFormRegister<any>
}

export const InputPassword: FunctionComponent<IInputPassword> = ({
    errors,
    register
}) => {

    const [isVisible, setIsVisible] = useState<boolean>(false)

    return (
        <>
        <FormControl isInvalid={!!errors.senha} mb={4}>
          <InputGroup>
            <FormInput
              borderRightRadius={0}
              type={isVisible ? 'text' : 'password'}
              placeholder="Senha"
              {...register("senha")}
            />
            <InputRightAddon
              onClick={() =>
                setIsVisible((value) =>
                  !value
                )
              }
            >
              {!isVisible ? <ViewIcon /> : <ViewOffIcon />}
            </InputRightAddon>
          </InputGroup>
          <FormErrorMessage color="#f1e3e3">
            {errors.senha && errors.senha.message}
          </FormErrorMessage>
        </FormControl>
        </>
    )
}